import { css, CSSResult } from 'lit'
import { csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const csePrice = {
  defaultBeforeColor: css`var(--cse-price-default-before-color, ${csColorText.body})`,
  saleColor: css`var(--cse-price-sale-color, ${csColorFunctional.sale})`,
  saleBeforeColor: css`var(--cse-price-sale-before-color, ${csColorText.muted})`,
  rowGap: css`var(--cse-price-row-gap, ${csSpacing.spacing02})`,
  segmentGap: css`var(--cse-price-segment-gap, ${csSpacing.spacing05})`,
  supportColor: css`var(--cse-price-support-color, ${csColorText.muted})`,
  justifyItems: css`var(--cse-price-justify-items, start)`
}

export const style: CSSResult = css`
  .cse-price {
    margin: 0;
    display: inline-grid;
    grid-template-areas:
      'top'
      'middle'
      'bottom';
    row-gap: ${csePrice.rowGap};
    justify-items: ${csePrice.justifyItems};
  }

  .cse-price__row {
    display: inline-flex;
    align-items: baseline;
    column-gap: ${csePrice.segmentGap};
    row-gap: ${csePrice.rowGap};
    flex-wrap: wrap;
  }

  .cse-price__row--top {
    grid-area: top;
  }

  .cse-price__row--middle {
    grid-area: middle;
  }

  .cse-price__row--bottom {
    grid-area: bottom;
  }

  .cse-price__lead,
  .cse-price__uom,
  .cse-price__vat {
    display: inline-flex;
    align-items: baseline;
    gap: ${csePrice.segmentGap};
  }

  .cse-price__uom,
  .cse-price__vat {
    white-space: nowrap;
    color: ${csePrice.supportColor};
  }

  .cse-price__lead {
    color: ${csePrice.defaultBeforeColor};
  }

  .cse-price__value {
    display: inline-flex;
    align-items: baseline;
  }

  .variant-sale .cse-price__lead {
    text-decoration: line-through;
    color: ${csePrice.saleBeforeColor};
  }

  .variant-sale .cse-price__value {
    color: ${csePrice.saleColor};
  }

  .cse-price.no-top-row {
    grid-template-areas:
      'middle'
      'bottom';
  }

  .cse-price.no-bottom-row {
    grid-template-areas:
      'top'
      'middle';
  }

  .cse-price.no-top-row.no-bottom-row {
    grid-template-areas:
      'middle';
  }
`
